import type { Icon } from '@tabler/icons-react';
import {
	IconBellRinging,
	IconChalkboard,
	IconArrowsExchange,
	IconCalendarEvent,
	IconDiamond
} from '@tabler/icons-react';

export const NOTIFICATIONS = 'notifications';
export const SIGNAL = 'signal';
export const ECONOMIC = 'economic';
export const ANALYSIS = 'analysis';
export const COMMUNITY = 'community';
export const SPECIAL = 'special';

export type NotificationsProps = {
	id: string;
	title: string;
	description: string;
	icon: Icon;
};

export const NotificationList: NotificationsProps[] = [
	{
		id: SIGNAL,
		title: 'signalNotificationTitle',
		description: 'signlaNotificationDescription',
		icon: IconArrowsExchange
	},
	{
		id: ECONOMIC,
		title: 'economicNotificationTitle',
		description: 'economicNotificationDescription',
		icon: IconCalendarEvent
	},
	{
		id: ANALYSIS,
		title: 'analysisNotificationTitle',
		description: 'analysisNotificationDescription',
		icon: IconChalkboard
	},
	{
		id: COMMUNITY,
		title: 'communtiyNotificationTitle',
		description: 'communityNotificationDescription',
		icon: IconDiamond
	},
	{
		id: SPECIAL,
		title: 'specialNotificationTitle',
		description: 'specialNotificationDescription',
		icon: IconBellRinging
	}
];

declare global {
	interface Window {
		NotificationHelper: () => void;
	}
}
export const notificationHelper = () => {
	(window as any).NotificationHelper = () => {
		let events = [];
		return new Promise(function (resolve) {
			resolve({
				getSubscriptions: function () {
					return new Promise(function (res) {
						res(events);
					});
				},
				unsubscribe: function (eventId) {
					return new Promise(function (res) {
						events = events.filter((x) => x !== eventId);
						res(events);
					});
				},
				subscribe: function (eventId) {
					return new Promise(function (res) {
						if (events.indexOf(eventId) < 0) events.push(eventId);
						res(events);
					});
				},
				isPushNotificationsEnabled: function () {
					return new Promise(function (res) {
						res(true);
					});
				},
				isPushNotificationsSupported: function () {
					return new Promise(function (res) {
						res(true);
					});
				},
				onPermissionChanged: function () {
					return new Promise(function (res) {
						res(true);
					});
				}
			});
		});
	};
};
